import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to cancel this subscription?", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "All users will have their licence removed.", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}

import { computed } from "vue";
import { Modal } from "uiv";


export default /*#__PURE__*/_defineComponent({
  __name: 'cancel-subscription-modal',
  props: {
    modelValue: { type: Boolean },
    subscriptionId: {},
    cancelError: {}
  },
  emits: ["toggle-cancel-subscription-modal", "cancel-subscription"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const displayModal = computed(() => {
  return props.modelValue;
});

const cancelSubscription = () => {
  emit("cancel-subscription", props.subscriptionId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    modelValue: displayModal.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((displayModal).value = $event)),
    title: "Are you sure?",
    footer: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-cancel-subscription-modal'))),
            class: "btn btn-default",
            style: {"margin-right":"2rem"}
          }, " Cancel "),
          _createElementVNode("button", {
            type: "button",
            onClick: cancelSubscription,
            class: "btn btn-primary"
          }, "Confirm")
        ]),
        (_ctx.cancelError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.cancelError), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})